import { Accordion as ChakraAccordion } from "@chakra-ui/react";
import styled from "styled-components";

export const Accordion = styled(ChakraAccordion)`
  font-size: 16px;
  font-weight: 300;
  color: #205aa7;
  border-top: 4px solid #eeeeee;
  height: calc(100% - 50px - 70px);
  /* overflow-y: auto; */
  /* scrollbar-color: #dddddd #eeeeee; */
  /* scrollbar-width: thin; */
  padding: 0;
  &::-webkit-scrollbar-track {
    background-color: #eeeeee;
  }

  &::-webkit-scrollbar {
    /* width: 7px; */
    /* background-color: #eeeeee; */
  }

  &::-webkit-scrollbar-thumb {
    background-color: #dddddd;
  }
  @media (min-width: 1024px) {
    overflow-y: scroll;
  }
`;
